import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaPercentage, FaGift, FaHandshake, FaChartLine, FaUsers, FaRocket, FaShieldAlt, FaTrophy, FaInfinity, FaGem } from 'react-icons/fa';
import { IoAddCircle, IoStatsChart, IoWallet, IoTrendingUp } from 'react-icons/io5';

const ProgramFeatures = () => {
    const { t } = useTranslation();
    return (
        <div className="program-features-content">
            <h2 className="program-features-title">{t('programFeatures.title')}</h2>
            <div className="program-features-grid">
                <div className="program-features-left">
                    <div className='program-feature-item'>
                        <div className="program-feature-icon">
                            <IoStatsChart size={50} />
                        </div>
                        <div>
                            <h5 className='program-feature-item-title'>
                                {t('programFeatures.f5Title')}
                            </h5>
                            <p className='program-feature-item-text'>
                                {t('programFeatures.f5Text')}
                            </p>
                        </div>
                    </div>

                    <div className="divider-line-horizontal"></div>

                    <div className='program-feature-item'>
                        <div className="program-feature-icon">
                            <FaPercentage size={50} />
                        </div>
                        <div>
                            <h5 className='program-feature-item-title'>
                                {t('programFeatures.f1Title')}
                            </h5>
                            <p className='program-feature-item-text'>
                                {t('programFeatures.f1Text')}
                            </p>
                        </div>
                    </div>

                    <div className="divider-line-horizontal"></div>

                    <div className='program-feature-item'>
                        <div className="program-feature-icon">
                            <FaGift size={50} />
                        </div>
                        <div>
                            <h5 className='program-feature-item-title'>
                                {t('programFeatures.f2Title')}
                            </h5>
                            <p className='program-feature-item-text'>
                                {t('programFeatures.f2Text')}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="program-features-divider">
                    <div className="divider-line-vertical"></div>
                </div>

                <div className="program-features-right">
                    <div className='program-feature-item'>
                        <div className="program-feature-icon">
                            <FaRocket size={50} />
                        </div>
                        <div>
                            <h5 className='program-feature-item-title'>
                                {t('programFeatures.f6Title')}
                            </h5>
                            <p className='program-feature-item-text'>
                                {t('programFeatures.f6Text')}
                            </p>
                        </div>
                    </div>

                    <div className="divider-line-horizontal"></div>

                    <div className='program-feature-item'>
                        <div className="program-feature-icon">
                            <FaHandshake size={50} />
                        </div>
                        <div>
                            <h5 className='program-feature-item-title'>
                                {t('programFeatures.f3Title')}
                            </h5>
                            <p className='program-feature-item-text'>
                                {t('programFeatures.f3Text')}
                            </p>
                        </div>
                    </div>

                    <div className="divider-line-horizontal"></div>

                    <div className='program-feature-item'>
                        <div className="program-feature-icon">
                            <FaChartLine size={50} />
                        </div>
                        <div>
                            <h5 className='program-feature-item-title'>
                                {t('programFeatures.f4Title')}
                            </h5>
                            <p className='program-feature-item-text'>
                                {t('programFeatures.f4Text')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProgramFeatures;
